export default __webpack_public_path__ + "static/media/APACHE RTR 200 4V_3.b8e21687.webp";